export default {
  pricing: {
    title: "Precios",
    hero: {
      title: "Una suscripción. Acceso total.",
      subtitle: "Empieza gratis. Desbloquea la experiencia completa en web y móvil.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "US$44.99 por todo el año",
      newsletterRenewLine: "Se renueva a US$59.99/año",
    },
    plans: {
      free: {
        features: [
          "Tendencias diarias",
          "Hit rates de equipos y jugadores",
          "Registros de partidos e historial de rendimiento",
        ],
      },
      annual: {
        billingShort: "año",
        billingLong: "anualmente",
        features: [
          "Incluye todo lo del plan gratis +",
          "Todas las señales de jugadas y análisis completo",
          "Alineaciones iniciales, impacto de lesiones y clima",
          "Acceso exclusivo a todos los parlays",
          "Análisis más profundo de todos los parlays en tendencia",
          "Filtros de búsqueda avanzados",
          "Opción para seleccionar y cambiar la vista de cuotas",
        ],
      },
      monthly: {
        billingShort: "mes",
        billingLong: "mensualmente",
        features: [
          "Incluye todo lo del plan gratis +",
          "Todas las señales de jugadas y análisis completo",
          "Alineaciones iniciales, impacto de lesiones y clima",
          "Acceso exclusivo a todos los parlays",
          "Análisis más profundo de todos los parlays en tendencia",
          "Filtros de búsqueda avanzados",
          "Opción para seleccionar y cambiar la vista de cuotas",
        ],
      },
    },
    actions: {
      currentPlan: "Tu plan actual",
      manage: "Administrar",
      upgrade: "Mejorar",
    },
    badges: {
      mostPopular: "Más popular",
      annualSavings: "Ahorra hasta un 60% con el plan anual",
    },
    operators: {
      prefix: "Totalmente integrado con",
      highlight: "operadores globales",
      suffix: "para una experiencia fluida desde la investigación hasta la apuesta",
    },
    sections: {
      fullPicture: "Ve el panorama completo antes de apostar",
      signals: "Desbloquea todas las señales para tener mejor contexto",
    },
    testimonials: {
      trusted: "Con la confianza de<br/>900k apostadores deportivos",
      betslips: "Más de<br/>1M+ betslips creados",
      previous: "Testimonios anteriores",
      next: "Siguientes testimonios",
      items: [
        {
          title: "La app mejor diseñada que he encontrado en mucho tiempo.",
          description: "Todo está justo donde debe estar, cada selección funciona como debería y la app está diseñada con mucho detalle. Tiene mucha información, pero aun así es eficiente y organizada. Como fanático de las estadísticas, le doy crédito a Linemate por su diseño y por lo fácil que hace encontrar buenas jugadas.",
        },
        {
          title: "La mejor app de todas",
          description: "Esta es 100% la mejor app para apuestas deportivas. Después de probarla unos días, me convenció. Recomiendo mucho la versión paga para aprovechar todo lo que ofrece. No te decepcionará.",
        },
        {
          title: "La mejor",
          description: "He probado muchas apps de estadísticas. Linemate es la que sigo usando. Ofrece mucho gratis, sigue agregando funciones sin quitar nada y el plan Plus vale mucho la pena. El soporte respondió en 5 minutos. Se nota que les importa ser la app de referencia.",
        },
        {
          title: "Gratamente sorprendido",
          description: "Si eres nuevo y sigues props a ciegas, los resultados pueden variar; igual necesitas estrategia. Descargué Linemate después de que mis parlays fallaran por poco, y mi primer parlay de 7 legs acertó. Por el precio mensual, con la primera semana gratis, vale la pena.",
        },
        {
          title: "Gran app",
          description: "Ninguna app de apuestas es perfecta, pero esta me ha dado los mejores resultados hasta ahora. Todo se basa en estadísticas y datos reales. La versión gratis es sólida y la suscripción es aún mejor.",
        },
        {
          title: "Una gran app que destaca",
          description: "Una gran app que realmente destaca, económica y con funciones fuertes para investigar. En general, excelente trabajo.",
        },
      ],
    },
    comparison: {
      premium: "Anual/Mensual",
      included: "Incluido",
      notIncluded: "No incluido",
    },
    popup: {
      billedAnnually: "Facturado anualmente",
      savePercent: "Ahorra {{percent}}%",
      upgradeForJust: "Mejorar por solo {{price}}/{{billingPeriod}}",
      dismiss: "Cerrar",
    },
  },
};
